import { useMemo } from 'react';
import { chain } from 'lodash';
import { fieldMappingSelector, globalOrderSelector } from 'slices/field.slice';
import { useAppSelector } from 'slices/store';
import { EFieldType, TType } from '@timeedit/types';

const useShownFields = (objectType: TType | null) => {
  const allFields = useAppSelector(fieldMappingSelector);
  const globalFieldOrder = useAppSelector(globalOrderSelector);

  const globalFieldOrderIndexMap = useMemo<Record<number, number>>(() => {
    const map: Record<number, number> = {};
    globalFieldOrder.forEach((field, index) => {
      map[field.id] = index;
    });
    return map;
  }, [globalFieldOrder]);

  return useMemo(() => {
    return chain([
      ...(objectType?.fields ?? []),
      ...(objectType?.parentFields ?? []),
    ])
      .filter((filterId) => filterId != null && filterId in allFields)
      .map((fieldId) => allFields[fieldId])
      .filter((field) => field?.fieldType !== EFieldType.REFERENCE)
      .sort((a, b) => {
        const firstFieldIndex =
          globalFieldOrderIndexMap[a.id] ?? Number.MAX_SAFE_INTEGER;
        const secondFieldIndex =
          globalFieldOrderIndexMap[b.id] ?? Number.MAX_SAFE_INTEGER;

        return firstFieldIndex - secondFieldIndex;
      })
      .value();
  }, [objectType, allFields, globalFieldOrderIndexMap]);
};

export default useShownFields;
